import React from 'react';
import { Stack, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from '../../../../../../../components/button';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';
import FlairIcon from '../../../../../../../atomic/atoms/FlairIcon';

type SalaryChangeStepOneProps = {
  onOptionSelect: (option: 'quick' | 'new') => void;
};

export const SalaryChangeStepOne: React.FC<
  React.PropsWithChildren<SalaryChangeStepOneProps>
> = ({ onOptionSelect }) => {
  const t = useNamespacedTranslation('changeRequests.requestForm.salaryChange');

  const quickUpdateTooltip = <Tooltip>{t('quickUpdateDescription')}</Tooltip>;

  const createNewTooltip = <Tooltip>{t('createNewDescription')}</Tooltip>;

  return (
    <div className="salary-change-step-one">
      <Stack gap={3}>
        <Row className="g-3">
          <Col md={6}>
            <OverlayTrigger placement="top" overlay={quickUpdateTooltip}>
              <div>
                <Button
                  variant="primary"
                  label={t('quickUpdate')}
                  onClick={() => onOptionSelect('quick')}
                  className="w-100">
                  <div className="d-flex align-items-center gap-2">
                    <FlairIcon icon="time-outline" size="sm" />
                    {t('quickUpdate')}
                  </div>
                </Button>
              </div>
            </OverlayTrigger>
          </Col>

          <Col md={6}>
            <OverlayTrigger placement="top" overlay={createNewTooltip}>
              <div>
                <Button
                  variant="primary"
                  label={t('createNew')}
                  onClick={() => onOptionSelect('new')}
                  className="w-100">
                  <div className="d-flex align-items-center gap-2">
                    <FlairIcon icon="add-circle-outline" size="sm" />
                    {t('createNew')}
                  </div>
                </Button>
              </div>
            </OverlayTrigger>
          </Col>
        </Row>
      </Stack>
    </div>
  );
};
